import styled from "styled-components";
import SEModal from "@streeteasy/design-system/deprecated/Modal";
import {
  Button as SEButton,
  buttonThemes,
  colors,
  componentSizes,
  TextLink,
  typography
} from "design-system";

import { smallScreen } from "src/shared/constants/screenSizes";

import { fairHousingIcon, landleaseBuildingIcon } from "../../assets";

const { H2, H6, P } = typography;

export const Modal = styled(SEModal).attrs({
  theme: "lightBox"
})`
  [aria-modal] {
    height: auto;
    top: 10%;
    width: 679px;

    @media screen and (min-width: ${smallScreen}px) {
      background-color: transparent;
      min-height: auto;
    }

    @media screen and (max-width: ${smallScreen}px) {
      min-height: 100vh;
      width: 100%;
      top: 0;
      background-color: ${colors.WHITE};
      margin: 0;
    }
  }
`;

const ModalTitle = styled.header`
  background-color: ${colors.ACCENT_PRIMARY_LIGHTEST};
  padding: 32px 185px 32px 56px;
  text-align: left;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 32px 24px;
  }
`;

export const RestrictedSaleModalTitle = styled(ModalTitle)`
  @media screen and (min-width: ${smallScreen}px) {
    background-image: url(${fairHousingIcon});
    background-position: right bottom;
    background-repeat: no-repeat;
  }
`;

export const LandLeaseSaleModalTitle = styled(ModalTitle)`
  @media screen and (min-width: ${smallScreen}px) {
    background-image: url(${landleaseBuildingIcon});
    background-position: right bottom;
    background-repeat: no-repeat;
  }
`;

export const ModalBody = styled.div`
  background-color: ${colors.WHITE};
  padding: 24px 56px 56px;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 24px 24px 105px;
  }
`;

export const Title = styled(H2)``;
export const SubTitle = styled(H6)`
  margin-bottom: 8px;
`;

export const Button = styled(SEButton).attrs({
  size: componentSizes.LG,
  theme: buttonThemes.PRIMARY
})`
  margin: 8px 0 24px;

  @media screen and (max-width: ${smallScreen}px) {
    margin: 0;
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  @media screen and (max-width: ${smallScreen}px) {
    background: ${colors.WHITE};
    border-top: 1px solid ${colors.GRAY_LIGHT};
    bottom: 0;
    left: 0;
    padding: 16px 24px;
    position: fixed;
    width: 100%;
  }
`;

export const Link = styled(TextLink).attrs({
  typography: "caps",
  underlined: false
})`
  display: block;

  &:hover,
  &:active {
    background-color: transparent;
  }
`;

export const Text = styled(P)`
  padding-bottom: 16px;
`;
